'use strict';

namespace Core {

    class BookingFormSummary {

        private links: any;
        private detailsLinkCaption: string;
        private changeLinkCaption: string;
        private workflowState: number;
        private imageurl: string;
        private title: string;
        private price: number | string;
        private details: any;

        constructor() {

            this.links = {
                details: {
                    enabled: false,
                    caption: this.detailsLinkCaption || ''
                },
                change: {
                    enabled: false,
                    caption: this.changeLinkCaption || '',
                    state: this.workflowState || 0,
                }
            };

            function changeWorkflow(state) {
                this.onChange(state);
            }

        }

    }

    angular
        .module('core')
        .directive('bookingFormSummary', ($route) => {
            return {
                link: (scope) => {
                    var type = $route.current.area;
                    scope.template = `partials/booking/template?name=BookingSummary${type}`;
                },
                template: `<div ng-include='template'></div>`
            };
        });
}
